import axios from "../../utils/axios"

export const getMarketingFaqs=async()=>{
    return await axios.get("api/marketingFaq/true")
}